import Vue from "vue";
import axios from "axios";
import moment from "moment";
import "../../filters";
import { WebCam } from "vue-web-cam";
import { find, last } from "lodash";
import * as files from "@/fileUtils";
import attachments from "@/components/attachments";

Vue.component(WebCam.name, WebCam);

export default {
  name: "Investigation",
  components: {
    InvestigationDetailComp: require("./investigation/investigationDetail.vue")
      .default,
    ManpowersComp: require("./common/manpowers.vue").default,
    SupportsComp: require("./common/supports.vue").default,
    AttachmentsComp: require("../../components/attachments.vue").default,
    CustomFieldsComp: require("../../components/customFields.vue").default,
    WebCam,
  },
  props: ["dataObj"],
  data: function () {
    return {
      selectedTab: "details",
      tabs: {
        Details: "details",
        Manpower: "manpower",
        SupportServices: "supportServices",
        Fileds: "fileds",
        Attachments: "attachments",
        Camera: "camera",
        Customfields: "customFields",
      },
      photoCaptured: false,
      // start
      window: {
        width: 0,
        height: 0,
        isMobile: false,
      }, //end
      investigationData: {
        id: -1,
        outcomeTypeId: -1,
        complainTypeId: -1,
        serviceTypeId: -1,
        investigationReasonId: -1,
        physicalAddress: "",
        stationId: -1,
        inspectorComment: "",
        workflowEmployeeId: -1,
        mActivityId: -1,
        elementTypeId: -1,
        elementId: -1,
        IsReadOnly: false,
        dataChildren: undefined,
      },
      activeTab: "tab-detail",
      omApplication: {},
      investigationId: -1,
      stations: [],
      employeeUsage: 2,
      bShowWarning: false,
      dataChildren: {
        sourceId: this.investigationId,
        empUsage: this.employeeUsage,
      },
      attachments: {
        files: [],
        permissions: { add: true, delete: true, download: true },
        sort: true,
        download: this.download,
        mimeTypes:
          "image/png,image/jpeg,application/pdf,application/msword,application/excel",
        multiple: false,
        maxFilesNumber: 3,
        cntrlItemsHelp: [],
      },
      customFields: {},
      bDisableButton: false,
      showImage: false,
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      message: "",
    };
  },
  computed: {
    outcomeTypeId: function () {
      return this.investigationData.outcomeTypeId;
    },
    device: function () {
      return find(this.devices, (n) => n.deviceId == this.deviceId);
    },
  },
  watch: {
    newStationId: function (value) {
      this.getWorkflowEmployees();
    },
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      //let firsty = head(this.devices);
      let firsty = last(this.devices);
      if (firsty) {
        this.camera = firsty.deviceId;
        this.deviceId = firsty.deviceId;
      }
    },
  },
  created() {
    this.$root.$on("photo_captured", () => (this.photoCaptured = true));
    this.omApplication = this.dataObj;
    this.investigationId = this.omApplication.investigationId;
    this.employeeUsage = 2;
    this.getInvestigation(this.investigationId);
    this.getInvestigationCustomFields();

    //start
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    //end
  },
  //start
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }, //end
  methods: {
    getInvestigationCustomFields() {
      axios
        .post("/Om/GetInvestigationCustomFields", {
          Value: this.investigationId,
        })
        .then((response) => {
          if (response.data.data.status == 0) {
            response.data.items.forEach((i) => {
              if (i.dateValue == "1899-12-30T00:00:00")
                i.dateValue = moment().format();

              if (i.dateTimeValue == "1899-12-30T00:00:00")
                i.dateTimeValue = moment().format();
            });
            this.customFields.items = response.data.items;

            this.$root.$emit("custom_fields_updated");
          } else {
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch((e) => {
          console.log("getInvestigationCustomFields");
          console.log(e);
          // this.$router.push('/login');
          return false;
        });
    },
    saveCustomFields(sMsg) {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      this.customFields.items.forEach((i) => {
        if (!i.dateValue) i.dateValue = "1899-12-30T00:00:00";

        if (!i.dateTimeValue) i.dateTimeValue = "1899-12-30T00:00:00";
      });
      var parameter = {
        ApplicationId: this.investigationId,
        Values: this.customFields.items,
        Language: this.$i18n.locale,
      };
      axios
        .post("/Om/SaveInvestigationCustomFieldValues", parameter)
        .then((response) => {
          if (response.data.data.status == 0) {
            this.$oldAlertMsg(sMsg, 2);
          } else this.$oldAlertMsg(response.data.data.text, 4);

          loader.hide();
        })
        .catch((e) => {
          console.log("saveCustomFields");
          console.log(e);
          loader.hide();
          this.$router.push("/login");
        });
    },
    setActiveTab(tabIndex) {
      this.activeTab = tabIndex;
    },
    //start
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (window.innerWidth <= 630) {
        this.window.isMobile = true;
      } else {
        this.window.isMobile = false;
      }
      //alert(this.window.isMobile + ', ' + window.innerWidth);
    }, //end
    getInvestigation(id) {
      axios
        .post("/Om/GetInvestigation", { Value: id })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.investigationData = response.data.item;

            this.investigationData.dateFromHH = moment(
              this.investigationData.dateTimeFrom
            ).format("HH");
            this.investigationData.dateFromMin = moment(
              this.investigationData.dateTimeFrom
            ).format("mm");
            this.investigationData.dateToHH = moment(
              this.investigationData.dateTimeTo
            ).format("HH");
            this.investigationData.dateToMin = moment(
              this.investigationData.dateTimeTo
            ).format("mm");
            this.investigationData.dateTimeFrom = new Date(
              this.investigationData.dateTimeFrom
            );
            this.investigationData.dateTimeTo = new Date(
              this.investigationData.dateTimeTo
            );

            this.dataChildren.sourceId = this.investigationId;
            this.dataChildren.empUsage = this.employeeUsage;

            this.investigationData.dataChildren = this.dataChildren;

            this.getAttachments(this.investigationId);

            this.$root.$emit("investigation_or_jobcard_updated");
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((e) => {
          this.$router.push("/login");
        });
    },
    saveDetails() {
      if (this.investigationData.outcomeTypeId >= 1 && !this.photoCaptured) {
        this.$alertMsg(this.$t("messages.CapturePhotoAlert"));
        return;
      }

      if (
        this.investigationData.outcomeTypeId === 1 &&
        this.investigationData.mActivityId === 0
      ) {
        this.bShowWarning = true;
        return;
      }

      let dteFrom = moment(this.investigationData.dateTimeFrom);
      dteFrom.set({
        hour: this.investigationData.dateFromHH,
        minute: this.investigationData.dateFromMin,
      });

      let dteTo = moment(this.investigationData.dateTimeTo);
      dteTo.set({
        hour: this.investigationData.dateToHH,
        minute: this.investigationData.dateToMin,
      });

      if (moment(dteFrom).isSameOrAfter(dteTo)) {
        this.$alertMsg(this.$t("messages.endDateBeforeStartDate"));
        return;
      }

      let param = {
        Id: this.investigationId,
        OutcomeTypeId: this.investigationData.outcomeTypeId,
        ComplainTypeId: this.investigationData.complainTypeId,
        ServiceTypeId: this.investigationData.serviceTypeId,
        InvestigationReasonId: this.investigationData.investigationReasonId,
        StationId: this.investigationData.stationId,
        InspectorComment: this.investigationData.inspectorComment ?? "",
        DateTimeFrom: moment(this.investigationData.dateTimeFrom).format(),
        DateTimeTo: moment(this.investigationData.dateTimeTo).format(),
        DateFromHH: this.investigationData.dateFromHH,
        DateFromMin: this.investigationData.dateFromMin,
        DateToHH: this.investigationData.dateToHH,
        DateToMin: this.investigationData.dateToMin,
      };

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/Om/UpdateInvestigationDetails", param)
        .then((response) => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t("messages.InvestSavedSuccess"), 2);
            this.setInvestigationElement();
            this.saveCustomFields(this.$t("messages.CustomFieldSavedSuccess"));
          } else this.$alertMsg(response.data.data.text);

          loader.hide();
        })
        .catch((e) => {
          loader.hide();
          this.$alertMsg(e.message);
        });
    },
    setInvestigationElement() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/Om/SetInvestigationElement", {
          ObjectId: this.investigationId,
          MActivityId: this.investigationData.mActivityId,
          ElementTypeId: this.investigationData.elementTypeId,
          ElementId: this.investigationData.elementId,
        })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t("messages.InvestElementSetSuccess"), 2);
          } else this.$alertMsg(response.data.data.text);

          loader.hide();
        })
        .catch((e) => {
          loader.hide();
          this.$alertMsg(e.message);
        });
    },
    completeInvestigation() {
      if (
        this.investigationData.outcomeTypeId === 1 &&
        this.investigationData.mActivityId === 0
      ) {
        this.bShowWarning = true;
        return;
      }

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/Om/UpdateInvestigationDetails", {
          Id: this.investigationId,
          OutcomeTypeId: this.investigationData.outcomeTypeId,
          ComplainTypeId: this.investigationData.complainTypeId,
          ServiceTypeId: this.investigationData.serviceTypeId,
          InvestigationReasonId: this.investigationData.investigationReasonId,
          StationId: this.investigationData.stationId,
          InspectorComment: this.investigationData.inspectorComment ?? "",
          DateTimeFrom: moment(this.investigationData.dateTimeFrom).format(),
          DateTimeTo: moment(this.investigationData.dateTimeTo).format(),
          DateFromHH: this.investigationData.dateFromHH,
          DateFromMin: this.investigationData.dateFromMin,
          DateToHH: this.investigationData.dateToHH,
          DateToMin: this.investigationData.dateToMin,
        })
        .then((response) => {
          if (response.data.data.status == 0) {
            axios
              .post("/Om/SetInvestigationElement", {
                ObjectId: this.investigationId,
                MActivityId: this.investigationData.mActivityId,
                ElementTypeId: this.investigationData.elementTypeId,
                ElementId: this.investigationData.elementId,
              })
              .then((response) => {
                if (response.data.data.status == 0) {
                  this.$alertMsg(
                    this.$t("messages.InvestElementSetSuccess"),
                    2
                  );

                  axios
                    .post("/Om/IssueJobcard", {
                      Type: this.omApplication.type,
                      ObjectsId: this.omApplication.investigationId, //this.omApplication.sourceId,
                      WorkflowEmployeeId:
                        this.investigationData.workflowEmployeeId,
                    })
                    .then((response) => {
                      if (response.data.data.status == 0) {
                        this.$alertMsg(
                          this.$t("messages.JobcardIssuedInvestCompleted"),
                          2
                        );
                        this.getInvestigation(this.investigationId);
                      } else this.$alertMsg(response.data.data.text);

                      loader.hide();
                    })
                    .catch((e) => {
                      this.$alertMsg(e.message);
                      loader.hide();
                    });
                } else this.$alertMsg(response.data.data.text);

                loader.hide();
              })
              .catch((e) => {
                loader.hide();
                this.$alertMsg(e.message);
              });
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((e) => {
          this.$alertMsg(e.message);
          loader.hide();
        });
    },
    processPhotos() {
      //process photo
      if (!this.img) return;

      var formData = new FormData();
      formData.append("objectId", this.investigationId.toString());
      formData.append("photoBase64", this.img);
      formData.append("source", "6");

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });

      return axios
        .post("/OmActivityBase/ProcessPhoto", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.$root.$emit("camera_photos_updated");
          this.getAttachments(this.investigationId);
          this.photoCaptured = true;
          loader.hide();
        })
        .catch((e) => {
          console.log("processPhotos");
          console.log(e);
          loader.hide();
          return false;
        });
    },
    getAttachments(investigationId) {
      this.bDisableButton = true;
      axios
        .get(
          "/OmActivityBase/GetAttachments?source=6&objectId=" + investigationId
        )
        .then((response) => {
          if (response.status == 200) {
            var files = response.data;
            this.attachments.files = [];
            for (var i = 0; i < files.length; ++i) {
              var file = files[i];
              this.attachments.files.push({
                id: file.id,
                seqId: 0,
                deleted: false,
                name: file.fileName,
              });
            }
          } else
            this.closeWithMessage(
              this.$t("messages.CannotGetAttachmentsFromServer"),
              1
            );
          this.bDisableButton = false;
        })
        .catch((e) => {
          console.log("getAttachments");
          console.log(e);
          this.bDisableButton = false;
          //this.$router.push('/login');
        });
    },
    processAttachments(uploadFiles, deleteFiles) {
      //process attachment
      var fileNameList = [];
      var formData = new FormData();
      formData.append("objectId", this.investigationId.toString());
      formData.append("source", "6");

      for (var i = 0; i < uploadFiles.length; ++i) {
        formData.append("uploadFiles", uploadFiles[i]);
        fileNameList.push(uploadFiles[i].name);
      }

      for (var i = 0; i < deleteFiles.length; ++i)
        formData.append("deleteFiles", deleteFiles[i]);

      this.bDisableButton = true;
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/OmActivityBase/ProcessAttachments", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.status == 200) {
            this.$alertMsg(this.$t("messages.AttachmentSavedSuccess"), 2);
            this.getAttachments(this.investigationId);
          } else this.$alertMsg(response.data.data.text);
          this.bDisableButton = false;
          loader.hide();
        })
        .catch((e) => {
          console.log("processAttachments");
          console.log(e);
          this.bDisableButton = false;
          loader.hide();
          return false;
        });
    },
    saveAttachments() {
      if (this.bDisableButton === true) return;

      var newFiles = [];
      var deleteFiles = [];

      this.attachments.files.forEach(function (file) {
        if (file.id < 0)
          // new
          newFiles.push(file.file);
        else if (file.deleted) deleteFiles.push(file.id);
      });

      if (deleteFiles.length > 0 || newFiles.length > 0)
        this.processAttachments(newFiles, deleteFiles);
    },
    savePhoto() {
      this.processPhotos();
      this.showImage = false;
    },
    discardPhoto() {
      this.img = null;
      this.showImage = false;
    },
    onCapture() {
      this.img = this.$refs.webcam.capture();
      this.$forceUpdate();
      this.showImage = true;
    },
    onStarted(stream) {
      //console.log('On Started Event', stream);
    },
    onStopped(stream) {
      //console.log('On Stopped Event', stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error, stream) {
      console.log("On Error Event", error, stream);
    },
    onCameras(cameras) {
      this.devices = cameras;
      //console.log('On Cameras Event', cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      //console.log('On Camera Change Event', deviceId);
    }, // End New Functions
    close() {
      this.$router.replace("/omApplications");
    },
    download(id) {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post(
          "/OmActivityBase/DownloadAttachment",
          { Value: id },
          { responseType: "blob" }
        )
        .then(files.getFile)
        .then((link) => {
          link.click();
        })
        .then((response) => {
          loader.hide();
        })
        .catch((err) => {
          console.log("download");
          console.log(err);
          loader.hide();
        });
    },
  },
};
